// extracted by css-extract-rspack-plugin
export default {"unorderedList":"src-UnorderedList-unorderedList-8eb2467c"};